import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { c as u, a as M } from "../../../index-CROKJrb5.js";
import { c as B, f as O } from "../../../create-component-CBAeEoQ6.js";
import { Typography as c } from "../../Typography/index.js";
import { ListItemIcon as x } from "../ListItemIcon/index.js";
import { useListStateAtoms as w } from "../ListState/index.js";
import { u as v } from "../../../react-B_GApDuV.js";
const C = u({
  base: "cur-shrink-0",
  variants: {
    size: {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      sm: "cur-mt-[.1875rem]",
      md: null,
      lg: null,
      xl: null
    }
  }
}), A = u({
  variants: {
    size: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    },
    hasIconStart: {
      true: null
    },
    hasIconEnd: {
      true: null
    },
    hasMetaOrBody: {
      true: null
    }
  },
  compoundVariants: [
    {
      size: "lg",
      hasMetaOrBody: !0,
      className: "-cur-mt-1"
    },
    {
      size: "md",
      hasMetaOrBody: !0,
      hasIconStart: !0,
      className: "-cur-mt-1"
    },
    {
      size: "md",
      hasMetaOrBody: !0,
      hasIconEnd: !0,
      className: "-cur-mt-1"
    },
    {
      size: "xl",
      hasMetaOrBody: !0,
      className: "cur-mt-[.125rem]"
    },
    {
      size: "xl",
      hasMetaOrBody: !1,
      className: "cur-mt-3"
    },
    {
      size: "lg",
      hasMetaOrBody: !1,
      hasIconEnd: !0,
      className: "cur-mt-1"
    }
  ]
}), L = u({
  base: "cur-flex cur-shrink-0 cur-gap-3 cur-items-start",
  variants: {
    size: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    },
    iconEndSize: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    },
    hasIconStart: {
      true: null
    },
    hasIconEnd: {
      true: null
    },
    hasMetaOrBody: {
      true: null
    }
  },
  compoundVariants: [
    {
      size: "sm",
      iconEndSize: "sm",
      className: "cur-mt-[.1875rem]"
    },
    {
      size: "lg",
      hasIconStart: !1,
      hasIconEnd: !1,
      className: "cur-mt-[.1875rem]"
    },
    {
      size: "lg",
      iconEndSize: "sm",
      hasMetaOrBody: !1,
      className: "cur-mt-[.4375rem]"
    },
    {
      size: "xl",
      hasIconStart: !0,
      hasIconEnd: !1,
      hasMetaOrBody: !0,
      className: "cur-mt-1"
    },
    {
      size: "xl",
      hasIconStart: !0,
      hasIconEnd: !1,
      hasMetaOrBody: !1,
      className: "cur-mt-4"
    }
  ]
}), b = u({
  variants: {
    iconEndSize: {
      sm: null,
      md: "cur-mt-1",
      lg: null,
      xl: null
    },
    hasIconStart: {
      true: null
    },
    hasIconEnd: {
      true: null
    }
  },
  compoundVariants: [
    {
      iconEndSize: "lg",
      hasIconStart: !0,
      className: "cur-mt-2"
    },
    {
      iconEndSize: "lg",
      hasIconEnd: !0,
      className: "cur-mt-2"
    },
    {
      iconEndSize: "xl",
      hasIconStart: !1,
      className: "cur-mt-4"
    }
  ]
}), F = B(
  "ListItem",
  O(
    ({
      as: f,
      children: i,
      className: z,
      iconEnd: o,
      iconStart: e,
      imageEnd: I,
      imageStart: g,
      meta: t,
      title: N,
      titleBold: p = !1,
      titleEnd: l,
      ...E
    }, S) => {
      const y = f || "li", { sizeAtom: j } = w(), a = v(j), m = e ? "sm" : a, r = !!e, n = !!o, d = !!(t || i), h = l && a === "xl" && !e;
      if (a === "xl" && r && n)
        throw new Error(
          "Cannot use an end icon with a start icon and an extra large list!"
        );
      if (a === "xl" && t)
        throw new Error("Cannot use meta with an extra large list!");
      return /* @__PURE__ */ s.jsxs(
        y,
        {
          ref: S,
          className: M(
            "cur-flex cur-w-full cur-list-none cur-gap-3",
            z
          ),
          ...E,
          children: [
            /* @__PURE__ */ s.jsxs("div", { className: "cur-flex cur-flex-grow cur-gap-3", children: [
              e ? /* @__PURE__ */ s.jsx("div", { className: C({ size: a }), children: /* @__PURE__ */ s.jsx(x, { icon: e }) }) : null,
              g,
              /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: A({
                    size: a,
                    hasIconStart: r,
                    hasIconEnd: n,
                    hasMetaOrBody: d
                  }),
                  children: [
                    /* @__PURE__ */ s.jsxs(
                      c,
                      {
                        weight: p || a !== "sm" ? "bold" : "normal",
                        className: "cur-flex cur-items-center",
                        children: [
                          N,
                          h ? /* @__PURE__ */ s.jsx(c, { size: "meta", className: "cur-ml-2", children: l }) : null
                        ]
                      }
                    ),
                    t ? /* @__PURE__ */ s.jsx(c, { size: "meta", className: "cur-text-subtle", children: t }) : null,
                    i
                  ]
                }
              )
            ] }),
            l || o ? /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: L({
                  size: a,
                  hasIconEnd: n,
                  hasIconStart: r,
                  hasMetaOrBody: d,
                  iconEndSize: m
                }),
                children: [
                  l && !h ? /* @__PURE__ */ s.jsx(
                    c,
                    {
                      size: "meta",
                      className: b({
                        hasIconEnd: n,
                        hasIconStart: r,
                        iconEndSize: m
                      }),
                      children: l
                    }
                  ) : null,
                  /* @__PURE__ */ s.jsx(x, { icon: o, size: m })
                ]
              }
            ) : null,
            I
          ]
        }
      );
    }
  )
);
export {
  F as ListItem
};
//# sourceMappingURL=index.js.map
